import { createSlice } from "@reduxjs/toolkit";
import { fetchTeamsData } from "../Thunks/teamsThunk";
import { addAsyncResourceThunk } from "../helpers/asyncResource";

const initialState = {
  data: null,
  loading: false,
  error: null,
  allListLoaded: false,
  allListData: null,
};

export const teamsSlice = createSlice({
  name: "teams",
  initialState,
  reducers: {
    clearTeams: (state) => {
      state.data = null;
      state.error = null;
      state.allListLoaded = false;
      state.allListData = null;
    },
  },
  extraReducers: (builder) => {
    addAsyncResourceThunk(builder, fetchTeamsData, {
      onFulfilled: (state, action) => {
        state.data = action.payload;
        if (action.meta?.arg?.getAll === true) {
          state.allListLoaded = true;
          state.allListData = action.payload;
        }
      },
    });
  },
});

export const { clearTeams } = teamsSlice.actions;
export const selectTeamsData = (state) => state.teams.data;
export const selectTeamsLoading = (state) => state.teams.loading;
export const selectTeamsError = (state) => state.teams.error;

export default teamsSlice.reducer;
